/**
 * Remembers the result of calling a function and consequtive calls reuse that value.
 * Note: doesn't differentiate on params
 * @param f {Function} the function to execute
 * @return {Function} a wrapper that always returns the first value f produced
 */
const memoize = (f) => {
  let isCached = false
  let cache
  return () => {
    if (isCached) {
      return cache
    }
    cache = f()
    isCached = true
    return cache
  }
}

export default memoize
